import { Chip } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import useAPI from "../../../../../api/hooks/useAPI";
import useColors from "../../../../../api/hooks/useColors";
import CustomToolTip from "../../../../../components/CustomTooltip";
import iconMapping from "../../../../../icons/IconMapping";
import { getEntitiesLabel, getEntitiesTooltip } from "./utils";

const InvolvedEntityChip = ({
  entitiesCount,
  type,
  setSelectedEntities,
  subtype = null,
  handleOnClick = null,
  sx = {},
  control = null,
  handleChipClick = null,
  entityTotal = null,
}) => {
  const [searchParams, setSearchParams] = useSearchParams("");
  const { trackEvent } = useAPI();

  let Icon =
    iconMapping[subtype] || iconMapping[type] || iconMapping["Internet"];

  const handleTrack = () => {
    // NOTE: this track message is monitored by Mixpanel to collect data on user engagement - DO NOT CHANGE IT
    const trackMessage = control
      ? `User clicked on misconfigured entities for control id ${control?.control_id}`
      : `User clicked on misconfigured entities for ${type} `;
    trackEvent(trackMessage);
  };

  const handleClick = (event) => {
    if (handleChipClick) {
      handleChipClick();
    }
    searchParams.set("entitiesDrawer", type);
    setSearchParams(searchParams.toString());
    handleTrack();
  };
  const handleOutsideClick = (event) => {
    if (setSelectedEntities) {
      if (handleOnClick) handleOnClick(event, type);
      else handleClick(event);
    } else return null;
  };

  const colors = useColors();
  const entityTypeForLabel = subtype ? subtype : type;
  const tooltipText = getEntitiesTooltip(
    entitiesCount,
    entityTypeForLabel,
    entityTotal
  );

  return (
    <CustomToolTip
      title={tooltipText}
      placement="top"
      disableHoverListener={!entityTotal}
    >
      <Chip
        label={`${getEntitiesLabel(entitiesCount, entityTypeForLabel)}`}
        onClick={handleOutsideClick}
        icon={<Icon style={{ color: colors.text_primary, width: "20px" }} />}
        style={{
          background: colors.entity_chip_enabled_fill,
          borderRadius: "8px",
          fontSize: "12px",
          color: colors.text_primary,
          boxShadow: colors.entity_chip_enabled_shadow,
          height: "24px",
          paddingLeft: "4px",
          ...sx,
        }}
      />
    </CustomToolTip>
  );
};

export default InvolvedEntityChip;
